"use client";

import { useEffect, useState } from "react";
import { getTaxonomyItems } from "@/lib/taxonomy-cache";

export type DiscoverBrandRow = {
  id: string;
  slug: string;
  name: string;
  sort_order: number | null;
};

export function useDiscoverBrands() {
  const [brands, setBrands] = useState<DiscoverBrandRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getTaxonomyItems({ type: "brand", parent: { mode: "root" } });
        if (cancelled) return;
        const rows: DiscoverBrandRow[] = data
          .filter((r) => typeof r.slug === "string" && r.slug.length > 0)
          .map((r) => ({ id: r.id, slug: r.slug as string, name: r.name, sort_order: r.sort_order }));
        setBrands(rows);
      } catch (err) {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : "Failed to load brands");
        setBrands([]);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { brands, isLoading, error };
}
